const $inject = ['$q', '$timeout'];

const lbaLeafletMapServiceService = function ($q, $timeout) {
  var service = {};

  service.getPosByAddress = function get(query, i) {
    let deferred = $q.defer();
    const delay = 500 * i;

    let service = new google.maps.places.PlacesService(document.createElement('div'));
    $timeout(function() {
      service.findPlaceFromQuery({query, fields: ['geometry']}, function(results, status) { 
        if (status === google.maps.places.PlacesServiceStatus.OK) {
          let lat = results[0].geometry.location.lat();
          let long = results[0].geometry.location.lng();
            deferred.resolve({lat, long});
          } 
          else {
            deferred.reject(status);
          }
        });
        
      }, delay);
    return deferred.promise;
  };

  return service;
};

lbaLeafletMapServiceService.$inject = $inject;

export default lbaLeafletMapServiceService;



// WEBPACK FOOTER //
// ./src/services/lbaLeafletMapService.js